// extracted by mini-css-extract-plugin
export default {"orderDetails":"OrderInformation_orderDetails__k5AMF","contentWrapper":"OrderInformation_contentWrapper__4CD-E"};